import { formatDate3, numberWithCommas, transNum } from '../../func/func';
import { MapCategory, MapItemCategory } from '../search/filter/SampleData';
import './markerInfo.css';

export const makeMarkers = (
  data: any,
  kakao: any,
  markerId: string,
  markerDetail: any,
  isDot?: boolean,
) => {
  if (isDot) {
    return Dotmarker(data, kakao, markerId);
  } else {
    if (data.type === 'A' || data.type === 'P') {
      return AuctionMarker(data, kakao, markerId, markerDetail);
    } else if (data.type === 'E') {
      return PlannedPropertyMarker(data, kakao, markerId, markerDetail);
    } else {
      return RealDealMarker(data, kakao, markerId, markerDetail);
    }
  }
};

const Dotmarker = (data: any, kakao: any, markerId: string) => {
  const auction = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3037_38880)">
      <circle cx="16" cy="16" r="8" fill="#F45551" fill-opacity="0.2" shape-rendering="crispEdges"/>
      </g>
      <g filter="url(#filter1_d_3037_38880)">
      <circle cx="16" cy="16" r="6" fill="#F45551"/>
      <circle cx="16" cy="16" r="5.5" stroke="#D22A26"/>
      </g>
      <defs>
      <filter id="filter0_d_3037_38880" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="4"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.956863 0 0 0 0 0.333333 0 0 0 0 0.317647 0 0 0 0.4 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3037_38880"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3037_38880" result="shape"/>
      </filter>
      <filter id="filter1_d_3037_38880" x="2" y="2" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="4"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.956863 0 0 0 0 0.333333 0 0 0 0 0.317647 0 0 0 0.4 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3037_38880"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3037_38880" result="shape"/>
      </filter>
      </defs>
    </svg>
  `;

  const pauction = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3037_38884)">
    <circle cx="16" cy="16" r="8" fill="#008AFF" fill-opacity="0.2" shape-rendering="crispEdges"/>
    </g>
    <circle cx="16" cy="16" r="5.5" fill="#008AFF" stroke="#1A71BB"/>
    <defs>
    <filter id="filter0_d_3037_38884" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="4"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 0.4 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3037_38884"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3037_38884" result="shape"/>
    </filter>
    </defs>
    </svg>
  `;
  const realDeal = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3037_38888)">
    <circle cx="16" cy="16" r="8" fill="#00A0B1" fill-opacity="0.2" shape-rendering="crispEdges"/>
    </g>
    <circle cx="16" cy="16" r="5.5" fill="#00A0B1" stroke="#0C7985"/>
    <defs>
    <filter id="filter0_d_3037_38888" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="4"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.627451 0 0 0 0 0.694118 0 0 0 0.4 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3037_38888"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3037_38888" result="shape"/>
    </filter>
    </defs>
    </svg>
  `;

  const plan = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3037_38892)">
    <circle cx="16" cy="16" r="8" fill="#C86700" fill-opacity="0.2" shape-rendering="crispEdges"/>
    </g>
    <circle cx="16" cy="16" r="5.5" fill="#C86700" stroke="#A55A0B"/>
    <defs>
    <filter id="filter0_d_3037_38892" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset/>
    <feGaussianBlur stdDeviation="4"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.784314 0 0 0 0 0.403922 0 0 0 0 0 0 0 0 0.4 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3037_38892"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3037_38892" result="shape"/>
    </filter>
    </defs>
    </svg>
  `;

  const content = () => {
    switch (data.type) {
      case 'A':
        return auction;
      case 'P':
        return pauction;
      case 'E':
        return plan;
      default:
        return realDeal;
    }
  };

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0.5,
    yAnchor: 0.1,
    content: `
      <div id="${markerId}" class="overlay-dot" >
        ${content()}
      </div>
    `,
    zIndex: 0,
  });
  return overlay;
};

const AuctionMarker = (
  data: any,
  kakao: any,
  markerId: string,
  markerDetail: any,
) => {
  const isActive =
    !!markerDetail && Number(markerDetail.iidx) === data.marker_idx;
  const content = `
  <div id="${markerId}">
    <div id="${markerId}-main-box" class="overlaybox" 
      style="${isActive ? `background: ${getTypeColor(data.type).color};` : ''}">
      <div class="overlay-boxHeader" style="background: ${getTypeColor(data.type).back};">
        <div class="overlay-label" style="background: ${getTypeColor(data.type).color};">
          ${data.type === 'A' ? '경매' : '공매'}
        </div>
        <div class="overlay-category" style="color: ${getTypeColor(data.type).color};">
          ${getCategory(data.item_code)}
        </div>
      </div>
      <div id="${markerId}-body" class="overlay-body ${isActive ? 'active' : ''}">
        <div class="overlay-price">${transNum(Number(data.price) ?? 0)}</div>
        <div class="overlay-area">${data.area}</div>
      </div>
      ${
        data.total_cnt && data.total_cnt > 1
          ? `<div class="overlay-count" style="background: ${getTypeColor(data.type).color};">${data.total_cnt}</div>`
          : ''
      } 

      ${
        data.status
          ? `<div class="overlay-status">
          ${
            data.type === 'P'
              ? data.status === '매각'
                ? '매각'
                : data.days > 0
                  ? `D - ${data.days}`
                  : '진행중'
              : data.status === '매각'
                ? data.status
                : data.days < 20 && data.days > -1
                  ? `D - ${data.days}`
                  : data.status
          }
        </div>`
          : ''
      }
      <div id="${markerId}-tail" class="overlay-tail" style="${isActive ? `border-top-color: ${getTypeColor(data.type).color};` : '--tail-back:#fff'}" />
    </div>
  </div>
  `;

  const zindex = isActive ? 2 : 1;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0,
    yAnchor: 1.0,
    content: content,
    zIndex: zindex,
  });
  return overlay;
};

const PlannedPropertyMarker = (
  data: any,
  kakao: any,
  markerId: string,
  markerDetail: any,
) => {
  const isActive =
    !!markerDetail && Number(markerDetail.iidx) === data.marker_idx;
  const { color: accent, back: accentBack } = getTypeColor(data.type);

  const boxHeaderStyle = `background:${isActive ? accent : accentBack};`;
  const labelStyle = `background:${isActive ? accentBack : accent};${isActive ? `color:${accent};` : ''}`;
  const categoryStyle = `color:${isActive ? '#fff' : accent};`;
  const tailClass = isActive ? 'active' : '';
  const tailStyle = `--tail-color:${accent};--tail-back:${accentBack};`;

  const countHtml =
    data.total_cnt && data.total_cnt > 1
      ? `<div class="overlay-count" style="background:${accent};">${data.total_cnt}</div>`
      : '';

  const content = `
  <div id="${markerId}" class="overlaybox">
    <div class="overlay-boxHeader" style="${boxHeaderStyle}" id="${markerId}-main-box" data-type="${data.type}" data-back="${accentBack}">
      <div class="overlay-label" style="${labelStyle}">
        예정
      </div>
      <div class="overlay-category" style="${categoryStyle}">
        ${getCategory(data.item_code)}
      </div>
    </div>
    ${countHtml}
    <div id="${markerId}-tail" class="overlay-tail ${tailClass}" style="${tailStyle}"></div>
  </div>
  `;

  const zindex = markerDetail && markerDetail.iidx === data.marker_idx ? 2 : 1;

  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0,
    yAnchor: 1.0,
    content: content,
    zIndex: zindex,
  });
  return overlay;
};

const RealDealMarker = (
  data: any,
  kakao: any,
  markerId: string,
  markerDetail: any,
) => {
  const dataIdx = data?.marker_idx ? data.marker_idx : data.iidx;
  const isActive = !!markerDetail && Number(markerDetail.iidx) === dataIdx;
  const content = `
  <div  id="${markerId}">
    <div id="${markerId}-main-box" class="overlaybox" style="${isActive ? `background: ${getTypeColor(data.type).color};` : ''}">
      <div class="overlay-boxHeader" style="background: ${getTypeColor(data.type).back};">
        <div class="overlay-label" style="background: ${getTypeColor(data.type).color};">
          실거래
        </div>
        <div class="overlay-category" style="color: ${getTypeColor(data.type).color};">
          ${getCategory(data.item_code)}
        </div>
      </div>
      <div id="${markerId}-body" class="overlay-body ${isActive ? 'active' : ''}">
        <div class="overlay-price"> ${data.type === 'D' ? `전세 ${transNum(Number(data.price) ?? 0)}` : data.type === 'M' ? `월세 ${transNum(Number(data.price) ?? 0)}/${transNum(Number(data.monthly_rent) ?? 0)}` : transNum(Number(data.price) ?? 0)}</div>
        <div class="overlay-area">${data.area}</div>
      </div>
      ${
        data.total_cnt && data.total_cnt > 1
          ? `<div class="overlay-count" style="background: ${getTypeColor(data.type).color};">${data.total_cnt}</div>`
          : ''
      } 

      ${
        data.status
          ? `<div class="overlay-status">
          ${
            data.type === 'P'
              ? data.status === '매각'
                ? '매각'
                : data.days > 0
                  ? `D - ${data.days}`
                  : '진행중'
              : data.status === '매각'
                ? data.status
                : data.days < 20 && data.days > -1
                  ? `D - ${data.days}`
                  : data.status
          }
        </div>`
          : ''
      }
      <div id="${markerId}-tail" class="overlay-tail" style="${isActive ? `border-top-color: ${getTypeColor(data.type).color};` : '--tail-back:#fff'}" />
    </div>
  </div>
    `;

  const zindex = isActive ? 2 : 1;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    clickable: true, // 마커를 클릭했을 때 지도의 클릭 이벤트가 발생하지 않도록 설정합니다
    xAnchor: 0,
    yAnchor: 1.0,
    content: content,
    zIndex: zindex,
  });
  return overlay;
};

// 매물 전체 리스트 표시 마커 생성
export const createCustomOverlay = (data: any, kakao: any) => {
  const clusterId = `cluster-${data.code}`;
  const overlay = new kakao.maps.CustomOverlay({
    position: new kakao.maps.LatLng(data.lat, data.lng),
    content: `
     <div id=${clusterId}
        style="width: max-content; border-radius: 8px; 
        // border: 1px solid #008AFF;
        overflow: hidden; box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12), 0px 1px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 1px 0px rgba(0, 0, 0, 0.08); display: ${data.name ? 'block' : 'none'};">
        <div
          style="padding: 5px 10px; background-color: #008AFF; color: white; font-family: 'Spoqa Han Sans Neo'; font-size: 12px; display: flex; flex-direction: row; justify-content: center; align-items: center; white-space:noWrap; text-align:center">
          ${data.name || ''}
        </div>
        <div
        style="width:100%;padding: 2px 10px; background-color: white; color: #171E26; font-family: 'Spoqa Han Sans Neo'; font-size: 14px; display: flex; justify-content: center; align-items: center;">
        ${Number(data.cnt).toLocaleString()}
      </div>
      </div>`,
    zIndex: 1,
  });

  return overlay;
};
export const customMarkerSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="46" viewBox="0 0 36 46" fill="none">
  <g clip-path="url(#clip0_1902_40962)">
    <mask id="mask0_1902_40962" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="46">
      <path d="M36 0H0V46H36V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_1902_40962)">
      <path d="M34.3813 16.1787L34.3815 16.1797C34.816 19.5878 34.0064 23.1005 32.5661 26.4544C31.128 29.8033 29.1001 32.9031 27.2144 35.4467L27.2126 35.4492C24.2183 39.506 20.9702 42.3977 18.4122 44.3455C18.155 44.5408 17.8214 44.5337 17.584 44.351L17.5781 44.3465C15.0199 42.3988 11.7711 39.5067 8.77629 35.4492L8.77555 35.4482C6.89439 32.904 4.86873 29.804 3.43164 26.4548C1.99246 23.1007 1.18288 19.5878 1.61738 16.1797L1.61751 16.1787C2.51203 9.12395 8.78068 1.5 17.9994 1.5C27.2182 1.5 33.4868 9.12395 34.3813 16.1787Z" fill="#00C46F" stroke="white" stroke-width="3"/>
      <path d="M18 26C22.4183 26 26 22.4183 26 18C26 13.5817 22.4183 10 18 10C13.5817 10 10 13.5817 10 18C10 22.4183 13.5817 26 18 26Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_1902_40962">
      <rect width="36" height="46" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

export const trafficMakersSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72692)">
    <mask id="mask0_2716_72692" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72692)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#3396FF"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#227DD1"/>
      <path d="M21.64 10.506C21.4 9.96598 20.86 9.62598 20.26 9.62598H11.74C11.14 9.62598 10.6 9.97598 10.36 10.506L8.62 14.446C8.54 14.626 8.5 14.826 8.5 15.016V21.996C8.5 22.396 8.84 22.726 9.25 22.726H10.75C11.16 22.726 11.5 22.396 11.5 21.996V21.266H20.5V21.996C20.5 22.396 20.84 22.726 21.25 22.726H22.75C23.16 22.726 23.5 22.396 23.5 21.996V15.016C23.5 14.816 23.46 14.626 23.38 14.446L21.64 10.506ZM12.04 12.206C12.17 11.956 12.43 11.806 12.71 11.806H19.28C19.56 11.806 19.82 11.966 19.95 12.206L21.24 14.716H10.74L12.03 12.206H12.04ZM11.5 19.086C10.67 19.086 10 18.436 10 17.626C10 16.816 10.67 16.166 11.5 16.166C12.33 16.166 13 16.816 13 17.626C13 18.436 12.33 19.086 11.5 19.086ZM19 17.626C19 16.826 19.67 16.166 20.5 16.166C21.33 16.166 22 16.816 22 17.626C22 18.436 21.33 19.086 20.5 19.086C19.67 19.086 19 18.436 19 17.626Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72692">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const schoolMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72711)">
    <mask id="mask0_2716_72711" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72711)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FFB301"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#D89000"/>
      <path d="M18.35 9.73566L16 8.30566V11.1757L18.35 9.73566Z" fill="white"/>
      <path d="M21.5 16.1758H10.5C9.95 16.1758 9.5 16.6258 9.5 17.1758V22.1758H14.5V19.1758H17.5V22.1758H22.5V17.1758C22.5 16.6258 22.05 16.1758 21.5 16.1758Z" fill="white"/>
      <path d="M16 11.1758L12.5 14.1758V16.1758H19.5V14.1758L16 11.1758ZM17 15.1758H15V14.1758H17V15.1758Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72711">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const publicOfficeMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72739)">
    <mask id="mask0_2716_72739" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72739)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FF7E1B"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#CC5E15"/>
      <path d="M20 10.1758H12C10.9 10.1758 10 11.0758 10 12.1758V22.1758H14.5V19.1758H17.5V22.1758H22V12.1758C22 11.0758 21.1 10.1758 20 10.1758ZM19 17.1758H13V15.1758H19V17.1758ZM19 14.1758H13V12.1758H19V14.1758Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72739">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

export const hospitalMarkesSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
  <g clip-path="url(#clip0_2716_72755)">
    <mask id="mask0_2716_72755" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="33">
      <path d="M32 0.175781H0V32.1758H32V0.175781Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_2716_72755)">
      <path d="M16 30.1758C23.732 30.1758 30 23.9078 30 16.1758C30 8.44379 23.732 2.17578 16 2.17578C8.26801 2.17578 2 8.44379 2 16.1758C2 23.9078 8.26801 30.1758 16 30.1758Z" fill="#FE639F"/>
      <path d="M16 3.17578C23.17 3.17578 29 9.00578 29 16.1758C29 23.3458 23.17 29.1758 16 29.1758C8.83 29.1758 3 23.3458 3 16.1758C3 9.00578 8.83 3.17578 16 3.17578ZM16 2.17578C8.27 2.17578 2 8.44578 2 16.1758C2 23.9058 8.27 30.1758 16 30.1758C23.73 30.1758 30 23.9058 30 16.1758C30 8.44578 23.73 2.17578 16 2.17578Z" fill="#D8397A"/>
      <path d="M20.5 9.67578H11.5C10.4 9.67578 9.5 10.5758 9.5 11.6758V20.6758C9.5 21.7758 10.4 22.6758 11.5 22.6758H20.5C21.6 22.6758 22.5 21.7758 22.5 20.6758V11.6758C22.5 10.5758 21.6 9.67578 20.5 9.67578ZM20 17.4258H17.25V20.1758H14.75V17.4258H12V14.9258H14.75V12.1758H17.25V14.9258H20V17.4258Z" fill="white"/>
    </g>
  </g>
  <defs>
    <clipPath id="clip0_2716_72755">
      <rect width="32" height="32" fill="white" transform="translate(0 0.175781)"/>
    </clipPath>
  </defs>
</svg>`;

const complex = (data: any) => {
  const complexId = `complex-${data.idx}`;
  const toggleId = `toggle-${data.idx}`;
  const imageSrc = convertImg(data.img);
  return `
<div id="${complexId}" class="complex-box">
<div
      style="
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      "
      >
        <div
        style="
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        font-size: 12px;
        font-weight: 500;
      "
        >
        <div
          style="
            background: ${getTypeColor(data.type).color};
            color: white;
            padding: 0px 4px;
          "
        >${getTypeColor(data.type).label}</div>
        <div
        style="
          color: ${getTypeColor(data.type).color};
        "
        >${getCategory(data.item_code)}</div>
        <div
          style="color:#E1E2E4;"
        >|</div>
        <div
        style="color: rgba(55, 56, 60, 0.61);"
        >${data.caseno}</div>
        </div>
      </div>
      <div
        style=" width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center; "
      >
        <div style="width:192px; font-size: 14px; font-weight: 700; color: black; display: flex; flex-direction:column; ">
          
          <div style="display: flex; flex-direction: column; justify-content: flex-start;  ">
            <div style="display: flex; flex-direction: row;  align-items: center; gap:4px; color:#616161; ">
              <div style="">감정</div>
              <div style="">${numberWithCommas(data.appraisal_prc, 0)}원</div>
            </div>
            <div style="display: flex; flex-direction: row;  align-items: center; gap:4px; color:#008AFF; ">
              <div style="">최저</div>
              <div style="">${numberWithCommas(data.min_prc, 0)}원</div>
            </div>
          </div>
          <div style="
                width:100%;
                display: flex; flex-direction: row; gap:4px; align-items: center; 
              "
          >
              <div style="
              width:124px;
                display: flex; flex-direction: row; align-items: center;
                font-size: 12px; font-weight: 500;line-height: 17.40px;
                // border: 1px solid ${getTypeColor(data.type).color}; 
                border-radius: 4px; 
              ">
                  <div style="
                    background: ${getTypeColor(data.type).color}; color: white; padding: 2px 4px;
                      border-top-left-radius: 4px; border-bottom-left-radius: 4px;
                  ">매각기일</div>
                  <div style="padding: 0px 4px; color: ${getTypeColor(data.type).color}">2024.01.01</div>
              </div>
              
              <div 
              id="${toggleId}"
              style="
                  border-radius: 999px;
                  // border: 1px solid #E1E2E4;
                  padding: 2px 6px;    
                  color: #616161;
                  font-size: 12px;
                  font-family: Spoqa Han Sans Neo;
                  font-weight: 500;
                  line-height: 17.40px;
                  word-wrap: break-word
              ">실거래가</div>
              </div>
          </div>
        <div style="display: flex; flex-direction: column; align-items: center; gap: 3px;">
          <img style="
          border-radius: 4px;
          width: 64px; height: 64px;
          "
          src=${imageSrc}
          ></img>     
        </div>
      </div>
</div>
`;
};

const getCategory = (category: string) => {
  const found = MapItemCategory.find(
    (item) => item.value.split(',').includes(category), // 쉼표(,)로 분리 후 category 포함 여부 확인
  );
  return found ? found.label : '기타'; // 매칭되는 값이 없으면 기본값 반환
};

export const getTypeColor = (type: string) => {
  switch (type.toUpperCase()) {
    case 'A':
      return {
        label: '경매',
        color: '#F45551',
        back: '#FFEFEF',
        stroke: '#D22A26',
      };
    case 'P':
      return {
        label: '공매',
        color: '#008AFF',
        back: '#EAF2FE',
        stroke: '#1A71BB',
      };
    case 'E':
      return {
        label: '예정',
        color: '#C86700',
        back: '#FFFCE3',
        stroke: '#A55A0B',
      };
    default:
      return {
        label: '실거래',
        color: '#00A0B1',
        back: '#E5F8FB',
        stroke: '#0C7985',
      };
  }
};

const convertImg = (img: string) => {
  let imageSrc = '/assets/images/marker/selected_marker_no_Image.svg'; // 기본 이미지 경로

  try {
    // data.img가 있을 경우 띄워쓰기를 %20으로 변환하고 이미지 경로로 사용
    if (img) {
      imageSrc = img.replace(/\s/g, '%20');
    }
  } catch (error) {
    console.error('이미지 경로 처리 중 오류 발생:', error);
  }
  return imageSrc;
};
